import { useEffect, useState } from "react";
import { Form } from "reactstrap";
import { APIMS } from "../../../../../../config/apims";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import ToastError from "../../../../../NotificationToast/ToastError";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";

export default function ModalCabangUpdate(props) {
  const token = localStorage.getItem("token");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  const [form, setForm] = useState({
    branch_code: "",
    branch_name: "",
    parent_id: "",
  });

  useEffect(() => {
    setForm({
      branch_code: props?.branchCodeUpdate || "",
      branch_name: props?.branchNameUpdate || "",
      parent_id: props?.parentIdUpdate || "",
    });
  }, [
    props?.branchCodeUpdate,
    props?.branchNameUpdate,
    props?.parentIdUpdate,
  ]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((previousForm) => ({
      ...previousForm,
      [name]: value,
    }));
  };

  const handleSubmit = useMutation(async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await APIMS.put(
        `/api/branches/${props.id}`,
        {
          branch_code: form.branch_code,
          branch_name: form.branch_name,
          parent_id: form.parent_id,
        },
        fetchParams
      );

      if (response?.status === 200) {
        ToastSuccess.fire({
          icon: "success",
          title: response.data.message,
        });
        props.GetResponseData();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memperbarui data",
      });
    } finally {
      setIsSubmitting(false);
    }
  });

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-update-cabang"
    >
      <div className="sims-modal-header">
        <div>
          <h5 id="modal-update-cabang" className="sims-modal-title">
            Update Cabang
          </h5>
        </div>

        <button
          type="button"
          className="sims-modal-close"
          onClick={props.onHide}
          aria-label="Tutup modal"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <Form onSubmit={(event) => handleSubmit.mutate(event)}>
        <div className="sims-modal-body">
          <div className="sims-form-group">
            <label className="sims-form-label" htmlFor="branch_code_update">
              Kode Cabang <span>*</span>
            </label>
            <input
              id="branch_code_update"
              className="sims-form-input"
              autoFocus
              required
              autoComplete="off"
              type="text"
              name="branch_code"
              onChange={handleChange}
              value={form.branch_code}
              
            />
          </div>

          <div className="sims-form-group">
            <label className="sims-form-label" htmlFor="branch_name_update">
              Nama Cabang <span>*</span>
            </label>
            <input
              id="branch_name_update"
              className="sims-form-input"
              required
              autoComplete="off"
              type="text"
              name="branch_name"
              onChange={handleChange}
              value={form.branch_name}
              
            />
          </div>
        </div>

        <div className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                Memperbarui...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faFloppyDisk} />
                Perbarui
              </>
            )}
          </button>
        </div>
      </Form>
    </Modal>
  );
}
